module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "content-wrapper"
  }, [(_vm.isVisibleErrorsModal) ? _c('errors') : _vm._e(), _vm._v(" "), (_vm.isTransactionModalVisible) ? _c('transaction', {
    attrs: {
      "informationMessage": "Transactions older than 1 Jan 2013 are not shown"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isInformationModalVisible) ? _c('information') : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.loading) ? _c('spinner') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "panelChart9"
    }
  }, [_c('dismissable-alert', {
    attrs: {
      "title": "You've purchased a Community Investment Note!",
      "subtitle": "Your investment will take 3 to 4 business days to be processed. You will receive a notification when it's completed.",
      "closeAction": _vm.hidePurchaseCompletedAlert,
      "isShowing": _vm.showPurchaseCompleted
    }
  }), _vm._v(" "), (!_vm.disableInvestment && (_vm.userStatus && _vm.userStatus.status !== 'no_status') && !_vm.isInstitutionAccount) ? _c('button', {
    staticClass: "btn btn-default btn-lg",
    attrs: {
      "type": "button",
      "disabled": _vm.isReadOnly
    },
    on: {
      "click": function($event) {
        _vm.purchaseNote()
      }
    }
  }, [_vm._v("\n                  Make an investment\n            ")]) : _vm._e(), _vm._v(" "), (_vm.userStatus && _vm.userStatus.status !== 'new') ? _c('div', [_c('div', {
    staticClass: "current-balance"
  }, [_c('p', {
    staticClass: "msg text-muted"
  }, [_vm._v("Current account balance: "), _c('strong', {
    staticClass: "amountBalance"
  }, [_vm._v(_vm._s(_vm.currentAmountBalance))])])])]) : _vm._e(), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive top-margin desktop-table"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "note-sort-title small-container",
    on: {
      "click": function($event) {
        _vm.sortByNoteId()
      }
    }
  }, [_c('span', {
    staticClass: "small-field"
  }, [_vm._v("Note number")]), _vm._v(" "), _c('em', {
    class: _vm.sortIconStyle('noteId')
  })])]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_c('div', {
    staticClass: "note-sort-title large-container",
    on: {
      "click": function($event) {
        _vm.sortNotes('currentBalance')
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('em', {
    class: _vm.sortIconStyle('currentBalance')
  })])]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_c('div', {
    staticClass: "note-sort-title large-container",
    on: {
      "click": function($event) {
        _vm.sortNotes('originalBalance')
      }
    }
  }, [_vm._m(3), _vm._v(" "), _c('em', {
    class: _vm.sortIconStyle('originalBalance')
  })])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "note-sort-title small-container",
    on: {
      "click": function($event) {
        _vm.sortNotes('interestRate')
      }
    }
  }, [_c('span', {
    staticClass: "small-field"
  }, [_vm._v("Rate")]), _vm._v(" "), _c('em', {
    class: _vm.sortIconStyle('interestRate')
  })])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "note-sort-title small-container",
    on: {
      "click": function($event) {
        _vm.sortNotes('interestTerm')
      }
    }
  }, [_c('span', {
    staticClass: "small-field"
  }, [_vm._v("Term")]), _vm._v(" "), _c('em', {
    class: _vm.sortIconStyle('interestTerm')
  })])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "note-sort-title small-container",
    on: {
      "click": function($event) {
        _vm.sortNotes('purchasedOn')
      }
    }
  }, [_vm._m(4), _vm._v(" "), _c('em', {
    class: _vm.sortIconStyle('purchasedOn')
  })])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "note-sort-title small-container",
    on: {
      "click": function($event) {
        _vm.sortNotes('openedOn')
      }
    }
  }, [_c('span', {
    staticClass: "small-field"
  }, [_vm._v("Open date")]), _vm._v(" "), _c('em', {
    class: _vm.sortIconStyle('openedOn')
  })])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "note-sort-title small-container",
    on: {
      "click": function($event) {
        _vm.sortNotes('maturityDate')
      }
    }
  }, [_c('span', {
    staticClass: "small-field"
  }, [_vm._v("Maturity date")]), _vm._v(" "), _c('em', {
    class: _vm.sortIconStyle('maturityDate')
  })])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "note-sort-title small-container",
    on: {
      "click": function($event) {
        _vm.sortByStatus()
      }
    }
  }, [_c('span', {
    staticClass: "small-field"
  }, [_vm._v("Status")]), _vm._v(" "), _c('em', {
    class: _vm.sortIconStyle('status')
  })])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("View details")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.orderedNotes), function(note) {
    return _c('tr', {
      key: note.noteId
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(note.noteId))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.formatAmount(note.currentBalance)))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.formatAmount(note.originalBalance)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.formatRate(note.interestRate)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.formatTerm(note.interestTerm)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.formatDate(note.purchasedOn)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.formatDate(note.openedOn)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.formatDate(note.maturityDate)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(note.status == 'cancelled') ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("Cancelled")]) : _vm._e(), _vm._v(" "), (note.status == 'failed') ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("Failed")]) : _vm._e(), _vm._v(" "), (note.status == 'pending') ? _c('span', {
      staticClass: "label label-warning"
    }, [_vm._v("Pending")]) : _vm._e(), _vm._v(" "), (note.status == 'open') ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("Open")]) : _vm._e(), _vm._v(" "), (note.status == 'closed') ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("Closed")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "btn btn-details btn-outline",
      attrs: {
        "type": "button",
        "disabled": _vm.isReadOnly
      },
      on: {
        "click": function($event) {
          _vm.goToViewDetail(note)
        }
      }
    }, [_vm._v("View details")])])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "mobile-card-view"
  }, [_c('div', {
    staticClass: "notes-cards-mobile"
  }, _vm._l((_vm.orderedNotes), function(note) {
    return _c('div', {
      key: note.noteId,
      staticClass: "note-card-mobile"
    }, [_c('div', {
      staticClass: "note-card-mobile-header"
    }, [_c('div', {
      staticClass: "note-card-mobile-number"
    }, [_c('span', {
      staticClass: "note-label"
    }, [_vm._v("Note")]), _vm._v(" "), _c('span', {
      staticClass: "note-number"
    }, [_vm._v(_vm._s(note.noteId))])]), _vm._v(" "), _c('span', {
      staticClass: "label note-status-badge",
      class: {
        'label-danger': note.status === 'cancelled' || note.status === 'failed' || note.status === 'closed',
          'label-warning': note.status === 'pending',
          'label-success': note.status === 'open'
      }
    }, [_vm._v("\n                    " + _vm._s(note.status) + "\n                  ")])]), _vm._v(" "), _c('div', {
      staticClass: "note-card-mobile-body"
    }, [_c('div', {
      staticClass: "note-card-mobile-row highlight-row"
    }, [_c('span', {
      staticClass: "note-card-mobile-label"
    }, [_vm._v("Current principal:")]), _vm._v(" "), _c('span', {
      staticClass: "note-card-mobile-value amount-value"
    }, [_vm._v(_vm._s(_vm.formatAmount(note.currentBalance)))])]), _vm._v(" "), _c('div', {
      staticClass: "note-card-mobile-row"
    }, [_c('span', {
      staticClass: "note-card-mobile-label"
    }, [_vm._v("Original principal:")]), _vm._v(" "), _c('span', {
      staticClass: "note-card-mobile-value"
    }, [_vm._v(_vm._s(_vm.formatAmount(note.originalBalance)))])]), _vm._v(" "), _c('div', {
      staticClass: "note-card-mobile-row"
    }, [_c('span', {
      staticClass: "note-card-mobile-label"
    }, [_vm._v("Rate:")]), _vm._v(" "), _c('span', {
      staticClass: "note-card-mobile-value"
    }, [_vm._v(_vm._s(_vm.formatRate(note.interestRate)))])]), _vm._v(" "), _c('div', {
      staticClass: "note-card-mobile-row"
    }, [_c('span', {
      staticClass: "note-card-mobile-label"
    }, [_vm._v("Term:")]), _vm._v(" "), _c('span', {
      staticClass: "note-card-mobile-value"
    }, [_vm._v(_vm._s(_vm.formatTerm(note.interestTerm)))])]), _vm._v(" "), _c('div', {
      staticClass: "note-card-mobile-row"
    }, [_c('span', {
      staticClass: "note-card-mobile-label"
    }, [_vm._v("Purchase date:")]), _vm._v(" "), _c('span', {
      staticClass: "note-card-mobile-value"
    }, [_vm._v(_vm._s(_vm.formatDate(note.purchasedOn)))])]), _vm._v(" "), _c('div', {
      staticClass: "note-card-mobile-row"
    }, [_c('span', {
      staticClass: "note-card-mobile-label"
    }, [_vm._v("Open date:")]), _vm._v(" "), _c('span', {
      staticClass: "note-card-mobile-value"
    }, [_vm._v(_vm._s(_vm.formatDate(note.openedOn)))])]), _vm._v(" "), _c('div', {
      staticClass: "note-card-mobile-row"
    }, [_c('span', {
      staticClass: "note-card-mobile-label"
    }, [_vm._v("Maturity date:")]), _vm._v(" "), _c('span', {
      staticClass: "note-card-mobile-value"
    }, [_vm._v(_vm._s(_vm.formatDate(note.maturityDate)))])])]), _vm._v(" "), _c('div', {
      staticClass: "note-card-mobile-action"
    }, [_c('button', {
      staticClass: "btn btn-mobile-details",
      attrs: {
        "type": "button",
        "disabled": _vm.isReadOnly
      },
      on: {
        "click": function($event) {
          _vm.goToViewDetail(note)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-eye"
    }), _vm._v(" View details\n                  ")])])])
  }))])], 1)])], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-heading"
  }, [_vm._v("\n      Manage Investments\n      "), _c('small', {
    attrs: {
      "data-localize": "dashboard.WELCOME"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "panel-title"
  }, [_c('span', {
    staticClass: "small-field"
  }, [_vm._v("Notes list")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field-container"
  }, [_c('span', [_vm._v("Current")]), _vm._v(" "), _c('span', [_vm._v("principal")]), _vm._v(" "), _c('span', [_vm._v("amount")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field-container"
  }, [_c('span', [_vm._v("\n                          Original\n                        ")]), _vm._v(" "), _c('span', [_vm._v("\n                          principal\n                        ")]), _vm._v(" "), _c('span', [_vm._v("\n                          amount\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field-container"
  }, [_c('span', {
    staticClass: "small-field"
  }, [_vm._v("Purchase date")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d2361e6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NotesList.vue
// module id = 2130
// module chunks = 1